import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext, createSelector } from '@ngxs/store';
import { IBaseTour } from './baseTour.model';
import { SetBaseTour, ClearBaseTour, SetTourPlacemark, SetMultipleTourPlacemarks, RemoveTourPlacemark, SetCurrentStepID } from './baseTour.actions';
import { IPlacemark } from '../placemarks.state/placemarks.model';

export class BaseTourStateModel {
  baseTour: IBaseTour | null = null;
  tourPlacemarks: IPlacemark[] = [];
  currentStepID: number | null = null;
}


@State<BaseTourStateModel>({
  name: 'StateBaseTour',
  defaults: new BaseTourStateModel()
})

@Injectable()
export class BaseTourState {

  @Selector()
  static getBaseTour(state: BaseTourStateModel): IBaseTour | null {
    return state.baseTour;
  }

  @Selector()
  static getTourPlacemarks(state: BaseTourStateModel): IPlacemark[] {
    return state.tourPlacemarks;
  }

  @Selector()
  static getCurrentStepID(state: BaseTourStateModel): number | null {
    return state.currentStepID;
  }

  static getTourPlacemarkById(id: string) {
    return createSelector([BaseTourState], (state: BaseTourStateModel): IPlacemark | undefined => {
      return state.tourPlacemarks.find(placemark => placemark.id === id);
    });
  }

  @Action(SetBaseTour)
  setBaseTour(ctx: StateContext<BaseTourStateModel>, {baseTour}: SetBaseTour) {
    ctx.patchState({
      baseTour: baseTour
    });
  }

  @Action(ClearBaseTour)
  clearBaseTour(ctx: StateContext<BaseTourStateModel>) {
    ctx.patchState({
      baseTour: null
    });
  }

  @Action(SetTourPlacemark)
  setTourPlacemark({getState, patchState }: StateContext<BaseTourStateModel>, { placemark, patchNewState }: SetTourPlacemark): void {
    const state = getState();
    const existingPMIndex: number = state.tourPlacemarks.findIndex((pm: IPlacemark) => pm.id === placemark.id);
    if (existingPMIndex >= 0) {
      state.tourPlacemarks[existingPMIndex] = placemark;
    } else {
      state.tourPlacemarks.push(placemark);
    }

    if (patchNewState) {
      patchState({
        tourPlacemarks: [...state.tourPlacemarks]
      });
    }
  }

  @Action(SetMultipleTourPlacemarks)
  setTourMultiplePlacemarks(stateContext: StateContext<BaseTourStateModel>, { placemarks }: SetMultipleTourPlacemarks): void {
    const state = stateContext.getState();

    placemarks.forEach((pm: IPlacemark) => {
      this.setTourPlacemark(stateContext, new SetTourPlacemark(pm, false));
    });

    stateContext.patchState({
      tourPlacemarks: [...state.tourPlacemarks]
    });
  }

  @Action(RemoveTourPlacemark)
  removeTourPlacemark(stateContext: StateContext<BaseTourStateModel>, { placemarkId }: RemoveTourPlacemark): void {
    const state = stateContext.getState();
    const updatedPlacemarks = state.tourPlacemarks.filter((pm: IPlacemark) => pm.id !== placemarkId);
    
    stateContext.patchState({
      tourPlacemarks: updatedPlacemarks
    });
  }

  @Action(SetCurrentStepID)
  setCurrentStepID(ctx: StateContext<BaseTourStateModel>, {stepID}: SetCurrentStepID) {
    ctx.patchState({
      currentStepID: stepID
    });
  }
}